import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

const Footer = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const scrollToTop = () => {
    location.reload();
  };
  const movePage = (path) => {
    // scrollToTop();
    navigate(path);
    window.location.reload();
  };

  return (
    <div className="footer_area">
      <div className="footer_box left">
        <div className="footer_logo_box">
          <Link to="/">
            <div className="footer_logo"></div>
          </Link>
        </div>
        <div className="footer_text_box">
          {/* <div className="footer_text top">
            605, BUILDING B 14 SAGIMAKGOL-RO,
            <br />
            45BEON-GIL, JUNGWON-GU, SEONGNAM-SI,
            <br />
            GYEONGGI-DO, REPUBLIC OF KOREA 13209
          </div>
          <div className="footer_text bottom">
           */}
          <div className="footer_text top">
            sklover777@dankook.ac.kr
            <br />
            cindy9510@naver.com
          </div>
        </div>
      </div>
      <div className="footer_box right">
        <div className="footer_navi_box">
          <div className="footer_navi">
            <div className="main_navi" onClick={() => movePage("/about")}>
              Company
            </div>
            <div className="sub_navi" onClick={() => movePage("/about")}>
              About
            </div>
            <div className="sub_navi" onClick={() => movePage("/ceo")}>
              CEO profile
            </div>
            <div className="sub_navi" onClick={() => movePage("/vision")}>
              Vision
            </div>
            <div className="sub_navi" onClick={() => movePage("/coretech")}>
              Technology
            </div>
          </div>
          <div className="footer_navi">
            <div className="main_navi" onClick={() => movePage("/project")}>
              Research
            </div>
            <div className="sub_navi" onClick={() => movePage("/project")}>
              Project
            </div>
            <div className="sub_navi" onClick={() => movePage("/publications")}>
              Publications
            </div>
            <div className="sub_navi" onClick={() => movePage("/patents")}>
              Patents
            </div>
          </div>
          <div className="footer_navi">
            <div className="main_navi" onClick={() => movePage("/news")}>
              News
            </div>
            <div className="sub_navi" onClick={() => movePage("/news")}>
              News
            </div>
          </div>
          <div className="footer_navi">
            <div className="main_navi" onClick={() => movePage("/contact")}>
              Contact
            </div>
            <div className="sub_navi" onClick={() => movePage("/contact")}>
              Contact Us
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
